import React from 'react'
import { createRoot } from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import App from 'containers/app'
import HttpHandler from 'components/http-handler'
import store from 'store'
import 'common/init'
import { getPartner } from 'common/misc'
import { Provider } from 'react-redux'
import theme from './theme'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { StyledEngineProvider } from '@mui/material/styles'
import { HelmetProvider } from 'react-helmet-async'

const container = document.getElementById('root-app')
const root = createRoot(container)

root.render(
  <Auth0Provider
    domain={AUTH_DOMAIN}
    clientId={AUTH_CID}
    authorizationParams={{
      partner: getPartner(),
      audience: AUTH_AUDIENCE,
      redirect_uri: window.location.origin,
    }}
    useRefreshTokens={true}
    cacheLocation="localstorage"
  >
    <HelmetProvider>
      <Provider store={store}>
        <HttpHandler store={store} baseURL={FARM_API_EP} />
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </StyledEngineProvider>
      </Provider>
    </HelmetProvider>
  </Auth0Provider>,
)
